/* eslint-disable unused-imports/no-unused-imports */
import React, {type FC, memo} from "react"

import SaleSash from "../../../saleSash"
import FitIcons from "../../../fitIcon"
import {NewInLabel} from "../../components"
import {Fits} from "../../../../config/constants"
import {TextModel} from "../../../../models/Text"

export interface ColourwaySwiperDetailsProps {
    displayNewIn: boolean
    fits?: Fits[]
    isOnSale: boolean
    showFitsIcons: boolean
    text: TextModel
    isOnServer?: boolean
}

export const ColourwaySwiperDetails: FC<ColourwaySwiperDetailsProps> = memo(
    ({displayNewIn, fits, showFitsIcons, isOnSale, text, isOnServer}) => (
        <>
            {!isOnServer && displayNewIn && <NewInLabel>{text.labels.newIn}</NewInLabel>}
            {!isOnServer && showFitsIcons && fits && <FitIcons fits={fits} />}
            <SaleSash isOnSale={isOnSale} />
        </>
    ),
)

ColourwaySwiperDetails.displayName = "ColourwaySwiperDetails"
